import { toRound } from '../../helpers/Format';
import React from 'react';
export var Checkins = function (_a) {
    var lines = _a.lines;
    return (lines.map(function (line) {
        return React.createElement("div", { key: line.id, style: {
                width: '90%',
                display: 'flex',
                flexWrap: 'wrap',
                flexDirection: 'row',
                justifyContent: 'flex-start',
            } },
            React.createElement("p", { style: { flex: 1 } }, "".concat(line.quantity, "x")),
            React.createElement("p", { style: { flex: 8, } }, line.passengerCategoryName),
            React.createElement("p", { style: { textAlign: 'end', } }, toRound(line.total)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Checkins.tsx
// module id = 1154
// module chunks = 0